import {
  ApplicationRef,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostListener,
} from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { WindowStore } from '@macs-frontend/core/store/window.store';
// xplat
import { AppBaseComponent } from '@macs-frontend/web';
import { Store } from '@ngrx/store';
import { action } from 'mobx-angular';
import { filter, takeUntil } from 'rxjs/operators';
import 'simplebar';
import { AuthService } from '../../../auth/services/auth.service';

@Component({
  selector: 'md-app',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent extends AppBaseComponent {
  @HostListener('window:resize')
  windowResize() {
    this.windowStore.changeWindow(window);
  }

  @HostListener('window:scroll')
  windowScroll() {
    this.windowStore.changeWindow(window);
  }

  constructor(
    router: Router,
    readonly cdr: ChangeDetectorRef,
    readonly store$: Store<any>,
    readonly appRef: ApplicationRef,
    readonly windowStore: WindowStore,
    readonly authService: AuthService,
  ) {
    super();

    Object.defineProperty(appRef, 'tick', {
      value: action(appRef.tick.bind(appRef)),
    });

    router.events
      .pipe(
        filter(event => event instanceof NavigationStart),
        takeUntil(this.destroy$),
      )
      // @ts-expect-error
      .subscribe((event: NavigationStart) => {
        if (
          !this.authService.isAuthenticated() &&
          !event.url.startsWith('/auth/') &&
          !event.url.startsWith('/invitation/') &&
          !event.url.startsWith('/public/')
        ) {
          router.navigate(['/auth/login']);
        }
      });
  }
}
